import React from "react";
import "./OfferStyles.css";

const Offers = () => {
  return (
    <>
      <div className="Ocontainer">
        <div className="weare">
          <h1>Who We Are</h1>
          <h4>
            We're your digital growth partners. Our team of experts specializes
            in Social Media Marketing Advertising (SMMA), helping businesses
            like yours thrive in the digital landscape. With data-driven
            strategies and creative excellence, we're here to drive your
            success. Join us on this journey to elevate your brand's online
            presence and achieve remarkable results.
          </h4>
        </div>
        <div className="Ocontent">
          <div className="offers">
            <h1>OFFERS</h1>
          </div>
          <h4>
            Our core service offered is Meta Ads(Lead Generation), alongside
            Social Media Management and Advertising Services.
          </h4>
          <h4>Get 10 new qualified leads within 30 days or you don't pay.</h4>
        </div>
        <div className="Processes">
          <h1>Our Processes</h1>
          <div className="pcontent">
            <div className="pcard">
              <h4> Gather Content </h4>
              <span className="bar"></span>
              <p className="eth">
                In the initial stage, we assemble essential content components
                like images, videos, and text. This content forms the building
                blocks for creating compelling marketing materials, ensuring we
                have the necessary resources to craft engaging campaigns that
                resonate with your target audience and yield impactful results.{" "}
              </p>
            </div>

            <div className="pcard">
              <h4> Launch Ads </h4>
              <span className="bar"></span>
              <p className="eth">
                After gathering content, this step involves strategically
                deploying your marketing materials across relevant platforms to
                maximize reach and engagement. Our focus is on making sure your
                ads leave a lasting impact and drive the desired actions from
                your audience. It's where strategy meets execution, and we're
                experts at making your brand shine in the digital world.
              </p>
            </div>

            <div className="pcard">
              <h4> Generate Leads </h4>
              <span className="bar"></span>
              <p className="eth">
                This phase focuses on converting engaged audiences into valuable
                leads. We use data-driven strategies to identify and capture
                potential customers interested in your offerings. Through
                effective calls-to-action and lead generation techniques, we
                transform prospects into leads, setting the stage for nurturing
                them into loyal customers. Quality leads are our priority,
                ensuring each one has the potential to become a brand advocate.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Offers;
